<template>
    <div id="removeclass">
       <app-modal
        :modal-id="modalId"
        modal-alignment="top"
        modal-size="fullscreen"
        @close-modal="closeModal"
      >
        <template slot="header">
          <h5 class="modal-title">{{ modalTitle }}</h5>
          <button
            type="button"
            class="btn btn-secondary mr-2"
            data-dismiss="modal"
            @click="closeModal"
          >
            {{ $t("close") }}
          </button>
        </template>
        <template slot="body">
          <div class="row">
            <div class="col-sm-12">
                <form-preview :id="formBody" :form_revision_id="formRevisionId" :form_id="formID" :response="type" :saveUserId="user_id"></form-preview>
                <!-- <form-preview v-if="type == 'save-response'" :id="formBody" :response="type" :form_revision_id="formRevisionId" :form_id="formID" :userId="user_id"></form-preview> -->
            </div>
          </div>
        </template>
      </app-modal>
         <AutoScroll :scrollableElementId="modalId"/>
    </div>
     
    </template>
    
    <script>
    import { FormMixin } from "../../../../../core/mixins/form/FormMixin";
    import { ModalMixin } from "../../../../../app/Mixins/ModalMixin";
    import AutoScroll from "@/app/Components/Helpers/AutoScroll";
    export default {
      name: "SaveResponseFormModal",
      mixins: [FormMixin, ModalMixin],
      components:{
        AutoScroll,

      },
      props: {
        type: String,
        formBody: Number,
        formRevisionId: Number,
        formID: Number,
        user_id: Number,
      },
      data() {
        return {
          modalId: "save_response_form_modal",
          modalTitle: this.$t("saved_response"),
        };
      },
      methods: {
      },
    };
    </script>